export function getDatacentersHeader(): string | null {
  // Matches old admin behavior exactly (jsonapi.interceptor.js):
  // if (data && data.availableDatacenters) { config.headers['x-c2fo-dc'] = data.availableDatacenters.join(','); }
  try {
    const settingsStr = localStorage.getItem('ADMIN_SETTINGS');
    if (settingsStr) {
      const settings = JSON.parse(settingsStr);
      if (settings && settings.availableDatacenters) {
        return settings.availableDatacenters.join(',');
      }
    }
  } catch {
    // Fall through - no header
  }

  // No ADMIN_SETTINGS or no availableDatacenters = no header (1:1 with old admin)
  return null;
}

export function flattenBroadcastResponse<T>(data: unknown): T[] {
  if (!data) return [];

  // If data is not an array, return empty
  if (!Array.isArray(data)) return [];

  // If empty array, return empty
  if (data.length === 0) return [];

  // Check if first element is an array (nested broadcast response)
  if (Array.isArray(data[0])) {
    // Flatten nested arrays: [[dc1_records], [dc2_records]] -> [all_records]
    return (data as T[][]).flat().filter((item): item is T => item != null && typeof item === 'object');
  }

  // Check if first element has a 'data' property (wrapped records)
  const firstItem = data[0] as Record<string, unknown>;
  if (firstItem && typeof firstItem === 'object' && 'data' in firstItem) {
    if (Array.isArray(firstItem.data)) {
      // Each element is { data: [records] }, flatten all: [{data:[...]}, {data:[...]}] -> [all_records]
      return (data as Array<{ data: T[] }>).flatMap((item) => item.data || []);
    }

    // Has 'data' property but not an array - unexpected format, return empty
    return [];
  }

  // Already a flat array of records
  return data as T[];
}
